import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'adminLicenses'

export const schema = new schemas.Array(new schemas.Entity(collection))

export const update = (callApi: CallApi) => (_: unknown, body: object) =>
  callApi(`${ADMIN_API_BASE}/batch/licenses`, schema, {
    method: 'PUT',
    body,
  })

export const remove = (callApi: CallApi) => (_: unknown, body: object) =>
  callApi(`${ADMIN_API_BASE}/batch/licenses`, schema, {
    method: 'DELETE',
    body,
  })
